/* eslint-disable no-bitwise */
export const AccountTypes = {
  Premium: 1,
  Pilot: 2,
  Free: 4,
  All: 1 | 2 | 4,
};
export const AccountTypesFull = new Map([
  [AccountTypes.Premium, { fullName: 'Premium', shortName: 'Premium' }],
  [AccountTypes.Pilot, { fullName: 'Pilot', shortName: 'Pilot' }],
  [AccountTypes.Free, { fullName: 'Free', shortName: 'Free' }],
  [AccountTypes.All, { fullName: 'All', shortName: 'All' }],
]);
export const OnlineStatuses = {
  Online: 'Online',
  Offline: 'Offline',
  LongOffline: 'LongOffline',
};

export const ActivationStatuses = {
  None: 'None',
  Activated: 'Activated',
};

export const GradeTypes = {
  PK: 1,
  K: 2,
  G1: 4,
  G2: 8,
  G3: 16,
  G4: 32,
  G5: 64,
  MG: 128,
  SPED: 256,
  All: 511,
};

export const Grades = new Map([
  [GradeTypes.PK, { fullName: 'Pre-Kindergarten', shortName: 'PK' }],
  [
    GradeTypes.K,
    {
      fullName: 'Kindergarten',
      shortName: 'K',
    },
  ],
  [
    GradeTypes.G1,
    {
      fullName: 'Grade 1',
      shortName: 'G1',
    },
  ],
  [
    GradeTypes.G2,
    {
      fullName: 'Grade 2',
      shortName: 'G2',
    },
  ],
  [
    GradeTypes.G3,
    {
      fullName: 'Grade 3',
      shortName: 'G3',
    },
  ],
  [
    GradeTypes.G4,
    {
      fullName: 'Grade 4',
      shortName: 'G4',
    },
  ],
  [
    GradeTypes.G5,
    {
      fullName: 'Grade 5',
      shortName: 'G5',
    },
  ],
  [
    GradeTypes.MG,
    {
      fullName: 'Multi-grade',
      shortName: 'MG',
    },
  ],
  [
    GradeTypes.SPED,
    {
      fullName: 'SPED',
      shortName: 'SPED',
    },
  ],
  [
    -1,
    {
      fullName: 'Ungroupped',
      shortName: 'Ungroupped',
    },
  ],
  [
    GradeTypes.All,
    {
      fullName: 'All',
      shortName: 'All',
    },
  ],
]);
export const concatGradeText = (gradeId) => {
  if (gradeId === GradeTypes.All) return 'All';

  const grades = Object.keys(GradeTypes).map((key) => {
    const id = GradeTypes[key];
    if ((gradeId & id) === id) return key;
    return undefined;
  });
  return grades.filter((g) => g).join(', ');
};

export const HelpLink =
  'https://help.happynumbers.com/en/articles/4934493-school-usage-report';

export const SortDirections = {
  None: 0,
  Asc: 1,
  Desc: 2,
};

export const invertSortDirection = (direction) =>
  direction === SortDirections.Desc ? SortDirections.Asc : SortDirections.Desc;

export const getColorByRate = (value) => {
  if (value >= 0 && value <= 19) return '#F34456';
  if (value >= 20 && value <= 59) return '#FFA51B';
  // if (value >= 60 && value <= 100) return '#479A19';

  return '#479A19';
};

export const GetTeacherDashboardRelativeUrl = (schoolId, teacherId, groupId) =>
  `/administrators/schools/${schoolId}/teachers/${teacherId}/groups/${groupId}/dashboard`;

export const ungroupTeachers = (grades) => {
  const ungrouppedTeachers = [];
  grades.forEach(({ teachers }) => ungrouppedTeachers.push(...teachers));
  // console.log(ungrouppedTeachers);
  return [{ gradeId: -1, teachers: ungrouppedTeachers }];
};
